const BROWSE = 'browse';
const MAX_FILE_SIZE = 'Max 10 MB file are allowed';
const ONLY_SUPPORTS = '⚠︎ Only supports .jpg, .jpeg, .png, .pdf';

const VARIABLES = [
  {
    label: 'Participant',
    value: 'PARTICIPANT',
    example: 'Mahmoud Bayoumi',
  },
  {
    label: 'Placement',
    value: 'PLACEMENT',
    example: 'GOLD VIP',
  },
  {
    label: 'Program',
    value: 'PROGRAM',
    example: 'Program 1',
  },
];

export { BROWSE, MAX_FILE_SIZE, ONLY_SUPPORTS, VARIABLES };
